import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/organization")({
	component: OrganizationLayoutPage,
	ssr: false,
});

function OrganizationLayoutPage() {
	return <Outlet />;
}
